export const CHILD_NAME_MAX = 120;
export const GRADE_MAX = 64;
export const NOTES_MAX = 2000;
export const SCHOOL_NAME_MAX = 200;
export const PHONE_MAX = 32;
export const RELATIONSHIP_MAX = 64;
export const CONTACT_NAME_MAX = 120;

export const CHILD_AGE_MIN = 0;
export const CHILD_AGE_MAX = 25;

export const PHONE_REGEX = /^[\d\s+()\-.ext]*$/i;
